/** Vibration haptic pour Android */
export function vibrate(pattern: number | number[] = 80): void {
    if ('vibrate' in navigator) {
        navigator.vibrate(pattern);
    }
}
export const vibrateSuccess = () => vibrate([80, 40, 80, 40, 200]);
export const vibrateError   = () => vibrate([200, 100, 200]);
export const vibrateTap     = () => vibrate(40);
